import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class QRApprovalService {

  constructor(private http: HttpClient) { }

  public token = ''

  getcampusdetail() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.printasseturl + '/apiV2/common/empCampuses', { headers });
  }

  getTableList(campusid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/campusWiseAssetDetails?campusId=' + campusid, { headers })
  }

  postApproval(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.orgUrl + '/apiV2/vehicleAssetTracking/saveVehicleApprovalDetails', payload, { headers })
  }

}
